import e, { useState as n, useEffect as t, useRef as o } from "react";
function r(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var t = 0, o = Array(n); t < n; t++) o[t] = e[t];
  return o;
}
function a(e, n, t, o, r, a, d) {
  try {
    var l = e[a](d),
      i = l.value;
  } catch (e) {
    return void t(e);
  }
  l.done ? n(i) : Promise.resolve(i).then(o, r);
}
function d(e) {
  return function () {
    var n = this,
      t = arguments;
    return new Promise(function (o, r) {
      var d = e.apply(n, t);
      function l(e) {
        a(d, o, r, l, i, "next", e);
      }
      function i(e) {
        a(d, o, r, l, i, "throw", e);
      }
      l(void 0);
    });
  };
}
function l(e, n, t) {
  return (n = function (e) {
    var n = function (e, n) {
      if ("object" != typeof e || !e) return e;
      var t = e[Symbol.toPrimitive];
      if (void 0 !== t) {
        var o = t.call(e, n || "default");
        if ("object" != typeof o) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === n ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof n ? n : n + "";
  }(n)) in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function i(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function s(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2 ? i(Object(t), !0).forEach(function (n) {
      l(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : i(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function c() {
  c = function c() {
    return n;
  };
  var e,
    n = {},
    t = Object.prototype,
    o = t.hasOwnProperty,
    r = Object.defineProperty || function (e, n, t) {
      e[n] = t.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    d = a.iterator || "@@iterator",
    l = a.asyncIterator || "@@asyncIterator",
    i = a.toStringTag || "@@toStringTag";
  function s(e, n, t) {
    return Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[n];
  }
  try {
    s({}, "");
  } catch (e) {
    s = function s(e, n, t) {
      return e[n] = t;
    };
  }
  function _(e, n, t, o) {
    var a = n && n.prototype instanceof v ? n : v,
      d = Object.create(a.prototype),
      l = new N(o || []);
    return r(d, "_invoke", {
      value: S(e, t, l)
    }), d;
  }
  function u(e, n, t) {
    try {
      return {
        type: "normal",
        arg: e.call(n, t)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  n.wrap = _;
  var b = "suspendedStart",
    p = "suspendedYield",
    m = "executing",
    f = "completed",
    T = {};
  function v() {}
  function h() {}
  function y() {}
  var O = {};
  s(O, d, function () {
    return this;
  });
  var g = Object.getPrototypeOf,
    w = g && g(g(I([])));
  w && w !== t && o.call(w, d) && (O = w);
  var x = y.prototype = v.prototype = Object.create(O);
  function E(e) {
    ["next", "throw", "return"].forEach(function (n) {
      s(e, n, function (e) {
        return this._invoke(n, e);
      });
    });
  }
  function j(e, n) {
    function t(r, a, d, l) {
      var i = u(e[r], e, a);
      if ("throw" !== i.type) {
        var s = i.arg,
          c = s.value;
        return c && "object" == typeof c && o.call(c, "__await") ? n.resolve(c.__await).then(function (e) {
          t("next", e, d, l);
        }, function (e) {
          t("throw", e, d, l);
        }) : n.resolve(c).then(function (e) {
          s.value = e, d(s);
        }, function (e) {
          return t("throw", e, d, l);
        });
      }
      l(i.arg);
    }
    var a;
    r(this, "_invoke", {
      value: function value(e, o) {
        function r() {
          return new n(function (n, r) {
            t(e, o, n, r);
          });
        }
        return a = a ? a.then(r, r) : r();
      }
    });
  }
  function S(n, t, o) {
    var r = b;
    return function (a, d) {
      if (r === m) throw Error("Generator is already running");
      if (r === f) {
        if ("throw" === a) throw d;
        return {
          value: e,
          done: !0
        };
      }
      for (o.method = a, o.arg = d;;) {
        var l = o.delegate;
        if (l) {
          var i = q(l, o);
          if (i) {
            if (i === T) continue;
            return i;
          }
        }
        if ("next" === o.method) o.sent = o._sent = o.arg;else if ("throw" === o.method) {
          if (r === b) throw r = f, o.arg;
          o.dispatchException(o.arg);
        } else "return" === o.method && o.abrupt("return", o.arg);
        r = m;
        var s = u(n, t, o);
        if ("normal" === s.type) {
          if (r = o.done ? f : p, s.arg === T) continue;
          return {
            value: s.arg,
            done: o.done
          };
        }
        "throw" === s.type && (r = f, o.method = "throw", o.arg = s.arg);
      }
    };
  }
  function q(n, t) {
    var o = t.method,
      r = n.iterator[o];
    if (r === e) return t.delegate = null, "throw" === o && n.iterator.return && (t.method = "return", t.arg = e, q(n, t), "throw" === t.method) || "return" !== o && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + o + "' method")), T;
    var a = u(r, n.iterator, t.arg);
    if ("throw" === a.type) return t.method = "throw", t.arg = a.arg, t.delegate = null, T;
    var d = a.arg;
    return d ? d.done ? (t[n.resultName] = d.value, t.next = n.nextLoc, "return" !== t.method && (t.method = "next", t.arg = e), t.delegate = null, T) : d : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, T);
  }
  function k(e) {
    var n = {
      tryLoc: e[0]
    };
    1 in e && (n.catchLoc = e[1]), 2 in e && (n.finallyLoc = e[2], n.afterLoc = e[3]), this.tryEntries.push(n);
  }
  function L(e) {
    var n = e.completion || {};
    n.type = "normal", delete n.arg, e.completion = n;
  }
  function N(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(k, this), this.reset(!0);
  }
  function I(n) {
    if (n || "" === n) {
      var t = n[d];
      if (t) return t.call(n);
      if ("function" == typeof n.next) return n;
      if (!isNaN(n.length)) {
        var r = -1,
          a = function t() {
            for (; ++r < n.length;) if (o.call(n, r)) return t.value = n[r], t.done = !1, t;
            return t.value = e, t.done = !0, t;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof n + " is not iterable");
  }
  return h.prototype = y, r(x, "constructor", {
    value: y,
    configurable: !0
  }), r(y, "constructor", {
    value: h,
    configurable: !0
  }), h.displayName = s(y, i, "GeneratorFunction"), n.isGeneratorFunction = function (e) {
    var n = "function" == typeof e && e.constructor;
    return !!n && (n === h || "GeneratorFunction" === (n.displayName || n.name));
  }, n.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, s(e, i, "GeneratorFunction")), e.prototype = Object.create(x), e;
  }, n.awrap = function (e) {
    return {
      __await: e
    };
  }, E(j.prototype), s(j.prototype, l, function () {
    return this;
  }), n.AsyncIterator = j, n.async = function (e, t, o, r, a) {
    void 0 === a && (a = Promise);
    var d = new j(_(e, t, o, r), a);
    return n.isGeneratorFunction(t) ? d : d.next().then(function (e) {
      return e.done ? e.value : d.next();
    });
  }, E(x), s(x, i, "Generator"), s(x, d, function () {
    return this;
  }), s(x, "toString", function () {
    return "[object Generator]";
  }), n.keys = function (e) {
    var n = Object(e),
      t = [];
    for (var o in n) t.push(o);
    return t.reverse(), function e() {
      for (; t.length;) {
        var o = t.pop();
        if (o in n) return e.value = o, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, n.values = I, N.prototype = {
    constructor: N,
    reset: function reset(n) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(L), !n) for (var t in this) "t" === t.charAt(0) && o.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(n) {
      if (this.done) throw n;
      var t = this;
      function r(o, r) {
        return l.type = "throw", l.arg = n, t.next = o, r && (t.method = "next", t.arg = e), !!r;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var d = this.tryEntries[a],
          l = d.completion;
        if ("root" === d.tryLoc) return r("end");
        if (d.tryLoc <= this.prev) {
          var i = o.call(d, "catchLoc"),
            s = o.call(d, "finallyLoc");
          if (i && s) {
            if (this.prev < d.catchLoc) return r(d.catchLoc, !0);
            if (this.prev < d.finallyLoc) return r(d.finallyLoc);
          } else if (i) {
            if (this.prev < d.catchLoc) return r(d.catchLoc, !0);
          } else {
            if (!s) throw Error("try statement without catch or finally");
            if (this.prev < d.finallyLoc) return r(d.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, n) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc <= this.prev && o.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var a = r;
          break;
        }
      }
      a && ("break" === e || "continue" === e) && a.tryLoc <= n && n <= a.finallyLoc && (a = null);
      var d = a ? a.completion : {};
      return d.type = e, d.arg = n, a ? (this.method = "next", this.next = a.finallyLoc, T) : this.complete(d);
    },
    complete: function complete(e, n) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && n && (this.next = n), T;
    },
    finish: function finish(e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var t = this.tryEntries[n];
        if (t.finallyLoc === e) return this.complete(t.completion, t.afterLoc), L(t), T;
      }
    },
    catch: function _catch(e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var t = this.tryEntries[n];
        if (t.tryLoc === e) {
          var o = t.completion;
          if ("throw" === o.type) {
            var r = o.arg;
            L(t);
          }
          return r;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(n, t, o) {
      return this.delegate = {
        iterator: I(n),
        resultName: t,
        nextLoc: o
      }, "next" === this.method && (this.arg = e), T;
    }
  }, n;
}
function _(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != t) {
      var o,
        r,
        a,
        d,
        l = [],
        i = !0,
        s = !1;
      try {
        if (a = (t = t.call(e)).next, 0 === n) {
          if (Object(t) !== t) return;
          i = !1;
        } else for (; !(i = (o = a.call(t)).done) && (l.push(o.value), l.length !== n); i = !0);
      } catch (e) {
        s = !0, r = e;
      } finally {
        try {
          if (!i && null != t.return && (d = t.return(), Object(d) !== d)) return;
        } finally {
          if (s) throw r;
        }
      }
      return l;
    }
  }(e, n) || function (e, n) {
    if (e) {
      if ("string" == typeof e) return r(e, n);
      var t = {}.toString.call(e).slice(8, -1);
      return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? r(e, n) : void 0;
    }
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function u(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var b,
  p = {
    exports: {}
  },
  m = {
    exports: {}
  },
  f = {};
var T,
  v,
  h,
  y,
  O,
  g,
  w,
  x,
  E,
  j,
  S,
  q,
  k,
  L,
  N = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function I() {
  return v || (v = 1, "production" === process.env.NODE_ENV ? m.exports = function () {
    if (b) return f;
    b = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      d = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      i = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      _ = e ? Symbol.for("react.suspense") : 60113,
      u = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      m = e ? Symbol.for("react.lazy") : 60116,
      T = e ? Symbol.for("react.block") : 60121,
      v = e ? Symbol.for("react.fundamental") : 60117,
      h = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;
    function O(e) {
      if ("object" == typeof e && null !== e) {
        var u = e.$$typeof;
        switch (u) {
          case n:
            switch (e = e.type) {
              case i:
              case s:
              case o:
              case a:
              case r:
              case _:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case c:
                  case m:
                  case p:
                  case d:
                    return e;
                  default:
                    return u;
                }
            }
          case t:
            return u;
        }
      }
    }
    function g(e) {
      return O(e) === s;
    }
    return f.AsyncMode = i, f.ConcurrentMode = s, f.ContextConsumer = l, f.ContextProvider = d, f.Element = n, f.ForwardRef = c, f.Fragment = o, f.Lazy = m, f.Memo = p, f.Portal = t, f.Profiler = a, f.StrictMode = r, f.Suspense = _, f.isAsyncMode = function (e) {
      return g(e) || O(e) === i;
    }, f.isConcurrentMode = g, f.isContextConsumer = function (e) {
      return O(e) === l;
    }, f.isContextProvider = function (e) {
      return O(e) === d;
    }, f.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, f.isForwardRef = function (e) {
      return O(e) === c;
    }, f.isFragment = function (e) {
      return O(e) === o;
    }, f.isLazy = function (e) {
      return O(e) === m;
    }, f.isMemo = function (e) {
      return O(e) === p;
    }, f.isPortal = function (e) {
      return O(e) === t;
    }, f.isProfiler = function (e) {
      return O(e) === a;
    }, f.isStrictMode = function (e) {
      return O(e) === r;
    }, f.isSuspense = function (e) {
      return O(e) === _;
    }, f.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === s || e === a || e === r || e === _ || e === u || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === p || e.$$typeof === d || e.$$typeof === l || e.$$typeof === c || e.$$typeof === v || e.$$typeof === h || e.$$typeof === y || e.$$typeof === T);
    }, f.typeOf = O, f;
  }() : m.exports = (T || (T = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      d = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      i = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      _ = e ? Symbol.for("react.suspense") : 60113,
      u = e ? Symbol.for("react.suspense_list") : 60120,
      b = e ? Symbol.for("react.memo") : 60115,
      p = e ? Symbol.for("react.lazy") : 60116,
      m = e ? Symbol.for("react.block") : 60121,
      f = e ? Symbol.for("react.fundamental") : 60117,
      T = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function h(e) {
      if ("object" == typeof e && null !== e) {
        var u = e.$$typeof;
        switch (u) {
          case n:
            var m = e.type;
            switch (m) {
              case i:
              case s:
              case o:
              case a:
              case r:
              case _:
                return m;
              default:
                var f = m && m.$$typeof;
                switch (f) {
                  case l:
                  case c:
                  case p:
                  case b:
                  case d:
                    return f;
                  default:
                    return u;
                }
            }
          case t:
            return u;
        }
      }
    }
    var y = i,
      O = s,
      g = l,
      w = d,
      x = n,
      E = c,
      j = o,
      S = p,
      q = b,
      k = t,
      L = a,
      I = r,
      P = _,
      C = !1;
    function M(e) {
      return h(e) === s;
    }
    N.AsyncMode = y, N.ConcurrentMode = O, N.ContextConsumer = g, N.ContextProvider = w, N.Element = x, N.ForwardRef = E, N.Fragment = j, N.Lazy = S, N.Memo = q, N.Portal = k, N.Profiler = L, N.StrictMode = I, N.Suspense = P, N.isAsyncMode = function (e) {
      return C || (C = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(e) || h(e) === i;
    }, N.isConcurrentMode = M, N.isContextConsumer = function (e) {
      return h(e) === l;
    }, N.isContextProvider = function (e) {
      return h(e) === d;
    }, N.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, N.isForwardRef = function (e) {
      return h(e) === c;
    }, N.isFragment = function (e) {
      return h(e) === o;
    }, N.isLazy = function (e) {
      return h(e) === p;
    }, N.isMemo = function (e) {
      return h(e) === b;
    }, N.isPortal = function (e) {
      return h(e) === t;
    }, N.isProfiler = function (e) {
      return h(e) === a;
    }, N.isStrictMode = function (e) {
      return h(e) === r;
    }, N.isSuspense = function (e) {
      return h(e) === _;
    }, N.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === s || e === a || e === r || e === _ || e === u || "object" == typeof e && null !== e && (e.$$typeof === p || e.$$typeof === b || e.$$typeof === d || e.$$typeof === l || e.$$typeof === c || e.$$typeof === f || e.$$typeof === T || e.$$typeof === v || e.$$typeof === m);
    }, N.typeOf = h;
  }()), N)), m.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function P() {
  if (y) return h;
  y = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    t = Object.prototype.propertyIsEnumerable;
  return h = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, t = 0; t < 10; t++) n["_" + String.fromCharCode(t)] = t;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (o, r) {
    for (var a, d, l = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(o), i = 1; i < arguments.length; i++) {
      for (var s in a = Object(arguments[i])) n.call(a, s) && (l[s] = a[s]);
      if (e) {
        d = e(a);
        for (var c = 0; c < d.length; c++) t.call(a, d[c]) && (l[d[c]] = a[d[c]]);
      }
    }
    return l;
  }, h;
}
function C() {
  if (g) return O;
  g = 1;
  return O = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function M() {
  return x ? w : (x = 1, w = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var A = I();
  p.exports = function () {
    if (q) return S;
    q = 1;
    var e = I(),
      n = P(),
      t = C(),
      o = M(),
      r = function () {
        if (j) return E;
        j = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = C(),
            t = {},
            o = M();
          e = function e(_e2) {
            var n = "Warning: " + _e2;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function r(r, a, d, l, i) {
          if ("production" !== process.env.NODE_ENV) for (var s in r) if (o(r, s)) {
            var c;
            try {
              if ("function" != typeof r[s]) {
                var _ = Error((l || "React class") + ": " + d + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              c = r[s](a, s, l, d, null, n);
            } catch (e) {
              c = e;
            }
            if (!c || c instanceof Error || e((l || "React class") + ": type specification of " + d + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), c instanceof Error && !(c.message in t)) {
              t[c.message] = !0;
              var u = i ? i() : "";
              e("Failed " + d + " type: " + c.message + (null != u ? u : ""));
            }
          }
        }
        return r.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (t = {});
        }, E = r;
      }(),
      a = function a() {};
    function d() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), S = function S(l, i) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        c = "@@iterator",
        _ = "<<anonymous>>",
        u = {
          array: f("array"),
          bigint: f("bigint"),
          bool: f("boolean"),
          func: f("function"),
          number: f("number"),
          object: f("object"),
          string: f("string"),
          symbol: f("symbol"),
          any: m(d),
          arrayOf: function arrayOf(e) {
            return m(function (n, o, r, a, d) {
              if ("function" != typeof e) return new p("Property `" + d + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
              var l = n[o];
              if (!Array.isArray(l)) return new p("Invalid " + a + " `" + d + "` of type `" + h(l) + "` supplied to `" + r + "`, expected an array.");
              for (var i = 0; i < l.length; i++) {
                var s = e(l, i, r, a, d + "[" + i + "]", t);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: m(function (e, n, t, o, r) {
            var a = e[n];
            return l(a) ? null : new p("Invalid " + o + " `" + r + "` of type `" + h(a) + "` supplied to `" + t + "`, expected a single ReactElement.");
          }),
          elementType: m(function (n, t, o, r, a) {
            var d = n[t];
            return e.isValidElementType(d) ? null : new p("Invalid " + r + " `" + a + "` of type `" + h(d) + "` supplied to `" + o + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return m(function (n, t, o, r, a) {
              if (!(n[t] instanceof e)) {
                var d = e.name || _;
                return new p("Invalid " + r + " `" + a + "` of type `" + ((l = n[t]).constructor && l.constructor.name ? l.constructor.name : _) + "` supplied to `" + o + "`, expected instance of `" + d + "`.");
              }
              var l;
              return null;
            });
          },
          node: m(function (e, n, t, o, r) {
            return v(e[n]) ? null : new p("Invalid " + o + " `" + r + "` supplied to `" + t + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return m(function (n, r, a, d, l) {
              if ("function" != typeof e) return new p("Property `" + l + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var i = n[r],
                s = h(i);
              if ("object" !== s) return new p("Invalid " + d + " `" + l + "` of type `" + s + "` supplied to `" + a + "`, expected an object.");
              for (var c in i) if (o(i, c)) {
                var _ = e(i, c, a, d, l + "." + c, t);
                if (_ instanceof Error) return _;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? m(function (n, t, o, r, a) {
              for (var d = n[t], l = 0; l < e.length; l++) if (b(d, e[l])) return null;
              var i = JSON.stringify(e, function (e, n) {
                return "symbol" === y(n) ? String(n) : n;
              });
              return new p("Invalid " + r + " `" + a + "` of value `" + String(d) + "` supplied to `" + o + "`, expected one of " + i + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), d);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), d;
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              if ("function" != typeof r) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + O(r) + " at index " + n + "."), d;
            }
            return m(function (n, r, a, d, l) {
              for (var i = [], s = 0; s < e.length; s++) {
                var c = (0, e[s])(n, r, a, d, l, t);
                if (null == c) return null;
                c.data && o(c.data, "expectedType") && i.push(c.data.expectedType);
              }
              return new p("Invalid " + d + " `" + l + "` supplied to `" + a + "`" + (i.length > 0 ? ", expected one of type [" + i.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return m(function (n, o, r, a, d) {
              var l = n[o],
                i = h(l);
              if ("object" !== i) return new p("Invalid " + a + " `" + d + "` of type `" + i + "` supplied to `" + r + "`, expected `object`.");
              for (var s in e) {
                var c = e[s];
                if ("function" != typeof c) return T(r, a, d, s, y(c));
                var _ = c(l, s, r, a, d + "." + s, t);
                if (_) return _;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return m(function (r, a, d, l, i) {
              var s = r[a],
                c = h(s);
              if ("object" !== c) return new p("Invalid " + l + " `" + i + "` of type `" + c + "` supplied to `" + d + "`, expected `object`.");
              var _ = n({}, r[a], e);
              for (var u in _) {
                var b = e[u];
                if (o(e, u) && "function" != typeof b) return T(d, l, i, u, y(b));
                if (!b) return new p("Invalid " + l + " `" + i + "` key `" + u + "` supplied to `" + d + "`.\nBad object: " + JSON.stringify(r[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var m = b(s, u, d, l, i + "." + u, t);
                if (m) return m;
              }
              return null;
            });
          }
        };
      function b(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function p(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function m(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          o = 0;
        function r(r, d, l, s, c, u, b) {
          if (s = s || _, u = u || l, b !== t) {
            if (i) {
              var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw m.name = "Invariant Violation", m;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var f = s + ":" + l;
              !n[f] && o < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + u + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[f] = !0, o++);
            }
          }
          return null == d[l] ? r ? null === d[l] ? new p("The " + c + " `" + u + "` is marked as required in `" + s + "`, but its value is `null`.") : new p("The " + c + " `" + u + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(d, l, s, c, u);
        }
        var d = r.bind(null, !1);
        return d.isRequired = r.bind(null, !0), d;
      }
      function f(e) {
        return m(function (n, t, o, r, a, d) {
          var l = n[t];
          return h(l) !== e ? new p("Invalid " + r + " `" + a + "` of type `" + y(l) + "` supplied to `" + o + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function T(e, n, t, o, r) {
        return new p((e || "React class") + ": " + n + " type `" + t + "." + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + r + "`.");
      }
      function v(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(v);
            if (null === e || l(e)) return !0;
            var n = function (e) {
              var n = e && (s && e[s] || e[c]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var t,
              o = n.call(e);
            if (n !== e.entries) {
              for (; !(t = o.next()).done;) if (!v(t.value)) return !1;
            } else for (; !(t = o.next()).done;) {
              var r = t.value;
              if (r && !v(r[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function h(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function y(e) {
        if (null == e) return "" + e;
        var n = h(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function O(e) {
        var n = y(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return p.prototype = Error.prototype, u.checkPropTypes = r, u.resetWarningCache = r.resetWarningCache, u.PropTypes = u, u;
    }, S;
  }()(A.isElement, !0);
} else p.exports = function () {
  if (L) return k;
  L = 1;
  var e = C();
  function n() {}
  function t() {}
  return t.resetWarningCache = n, k = function k() {
    function o(n, t, o, r, a, d) {
      if (d !== e) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }
    function r() {
      return o;
    }
    o.isRequired = o;
    var a = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  };
}()();
var R = u(p.exports);
function $(e, n) {
  void 0 === n && (n = {});
  var t = n.insertAt;
  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
      r = document.createElement("style");
    r.type = "text/css", "top" === t && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}
var Y = "OddsTable-module_OddsTable__wrapper__neqO2",
  F = "OddsTable-module_OddsTable__cont__uKogI",
  U = "OddsTable-module_collapsible__Cj0fN",
  W = "OddsTable-module_OddsTable_header__cont__CdUxp",
  V = "OddsTable-module_OddsTable_body__cont__14XlU",
  B = "OddsTable-module_OddsTable_odd__cont__IFZaw",
  z = "OddsTable-module_OddsTable_odd_row__ivujt",
  D = "OddsTable-module_OddsTable_odd__0yWTX",
  Z = "OddsTable-module_OddsTable_hover_area__MMLYC",
  G = "OddsTable-module_OddsTable_odd_team__cu7WY",
  J = "OddsTable-module_OddsTable_odd_team_image__J8OSR",
  H = "OddsTable-module_OddsTable_odd_team_text__0Fe-1",
  X = "OddsTable-module_OddsTable_odd_team_subtext__SRZk-",
  K = "OddsTable-module_OddsTable_odd_value__ozabf",
  Q = "OddsTable-module_OddsTable_empty_message__STUm-",
  ee = "OddsTable-module_OddsTable_expand_button__pMPOq",
  ne = "OddsTable-module_OddsTable_expand_chevron__YhTDr",
  te = "OddsTable-module_up__n9yuq",
  oe = "OddsTable-module_down__gLPSd",
  re = "OddsTable-module_OddsTable_sponsor_mobile__cont__NMUBC",
  ae = "OddsTable-module_OddsTable_sponsor__cont__pojw0";
$('.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable__cont__uKogI {\n  background-color: white;\n  font-family: "protipo-narrow";\n  border-top: 1px solid #cecece;\n  border-bottom: 1px solid #cecece;\n  overflow: hidden;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable__cont__uKogI {\n    border-radius: 16px 0px 16px 0px;\n    border: 1px solid #cecece;\n  }\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable__cont__uKogI.OddsTable-module_collapsible__Cj0fN {\n    border-radius: 16px 0px 0px 0px;\n    border: 1px solid #cecece;\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_header__cont__CdUxp {\n  border-bottom: 1px solid #cecece;\n  position: relative;\n  padding: 0 0 0 24px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_body__cont__14XlU {\n  padding: 0 24px 0px 24px;\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_body__cont__14XlU {\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: space-around;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_body__cont__14XlU::after {\n    content: "";\n    flex: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_body__cont__14XlU {\n    justify-content: space-between;\n    padding: 0 0 0 24px;\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw {\n  position: relative;\n  padding-top: 20px;\n  display: flex;\n  flex: 1;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-of-type {\n  padding-bottom: 20px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-of-type .OddsTable-module_OddsTable_odd_row__ivujt {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-of-type:after {\n  content: none !important;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw {\n    flex-shrink: 0;\n    flex-grow: 0;\n    flex-basis: 50%;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-child, .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-last-child(2) {\n    padding-bottom: 20px;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-child .OddsTable-module_OddsTable_odd_row__ivujt, .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-last-child(2) .OddsTable-module_OddsTable_odd_row__ivujt {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-of-type(odd):after {\n    content: "";\n    background-color: #cecece;\n    display: block;\n    position: absolute;\n    left: calc(100% - 28px);\n    top: 15%;\n    width: 1px;\n    height: 70%;\n  }\n}\n@media (min-width: 1200px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw {\n    flex-basis: 33.333%;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-child, .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-last-child(2), .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-last-child(3) {\n    padding-bottom: 20px;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:last-child .OddsTable-module_OddsTable_odd_row__ivujt, .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-last-child(2) .OddsTable-module_OddsTable_odd_row__ivujt, .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-last-child(3) .OddsTable-module_OddsTable_odd_row__ivujt {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-of-type(odd):after {\n    content: none;\n  }\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-of-type(3n-1):after, .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__cont__IFZaw:nth-of-type(3n-2):after {\n    content: "";\n    background-color: #cecece;\n    display: block;\n    position: absolute;\n    left: calc(100% - 50px);\n    top: 15%;\n    width: 1px;\n    height: 70%;\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd__0yWTX {\n  width: 100%;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_hover_area__MMLYC {\n  background-color: #cecece;\n  width: calc(100% + 48px);\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: -24px;\n  opacity: 0;\n  z-index: 1;\n  transition: opacity 0.2s;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_hover_area__MMLYC {\n    width: 100%;\n    left: -28px;\n  }\n}\n@media (min-width: 1200px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_hover_area__MMLYC {\n    left: -50px;\n    width: 100%;\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_hover_area__MMLYC:hover {\n  opacity: 0.2;\n  cursor: pointer;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_row__ivujt {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 2;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_row__ivujt:nth-of-type(2) {\n  margin-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #cecece;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_row__ivujt {\n    width: calc(100% - 56px);\n  }\n}\n@media (min-width: 1200px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_row__ivujt {\n    width: calc(100% - 100px);\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_team__cu7WY {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_team_image__J8OSR {\n  width: 24px;\n  height: 24px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_team_image__J8OSR img {\n  width: 100%;\n  height: 100%;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_team_text__0Fe-1 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-left: 16px;\n  display: flex;\n  flex-direction: row;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_team_subtext__SRZk- {\n  font-weight: normal;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_odd_value__ozabf {\n  font-size: 15px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_empty_message__STUm- {\n  flex: 1;\n  text-align: center;\n  color: #8a9299;\n  font-size: 16px;\n  line-height: 18px;\n  padding: 45px 12px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_expand_button__pMPOq {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  font-family: "protipo-narrow";\n  color: #005eb8;\n  font-size: 16px;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #cecece;\n  cursor: pointer;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_expand_button__pMPOq:hover {\n  text-decoration: underline;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_expand_button__pMPOq {\n    border-bottom: 1px solid #cecece;\n    border-right: 1px solid #cecece;\n    border-left: 1px solid #cecece;\n    border-radius: 0 0 16px 0;\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_expand_chevron__YhTDr {\n  border-style: solid;\n  border-width: 2px 2px 0 0;\n  content: "";\n  height: 8px;\n  width: 8px;\n  left: 4px;\n  position: relative;\n  margin-left: 4px;\n  transition: transform 0.2s ease-in-out;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_expand_chevron__YhTDr.OddsTable-module_up__n9yuq {\n  transform: rotate(-45deg);\n  top: 3px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_expand_chevron__YhTDr.OddsTable-module_down__gLPSd {\n  transform: rotate(135deg);\n  top: -2px;\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_sponsor_mobile__cont__NMUBC {\n  height: 30px;\n  margin-top: 22px;\n  margin-left: 24px;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_sponsor_mobile__cont__NMUBC {\n    display: none;\n  }\n}\n.OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_sponsor__cont__pojw0 {\n  height: 40px;\n  position: absolute;\n  right: 24px;\n  top: 0;\n  display: none;\n}\n@media (min-width: 768px) {\n  .OddsTable-module_OddsTable__wrapper__neqO2 .OddsTable-module_OddsTable_sponsor__cont__pojw0 {\n    display: flex;\n  }\n}');
var de = [{
  slug: "nhl",
  displayName: "NHL"
}, {
  slug: "mlb",
  displayName: "MLB"
}, {
  slug: "wnba",
  displayName: "WNBA"
}, {
  slug: "cfl",
  displayName: "CFL"
}, {
  slug: "mls",
  displayName: "MLS"
}];
function le() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return e.wins >= 0 && e.draws >= 0 && e.losses >= 0 ? " (".concat(e.wins, "-").concat(e.draws, "-").concat(e.losses, ")") : e.wins >= 0 && e.losses >= 0 && e.ties >= 0 ? " (".concat(e.wins, "-").concat(e.losses, "-").concat(e.ties, ")") : e.wins >= 0 && e.losses >= 0 && e.overtime_losses >= 0 ? " (".concat(e.wins, "-").concat(e.losses, "-").concat(e.overtime_losses, ")") : e.wins >= 0 && e.losses >= 0 ? " (".concat(e.wins, "-").concat(e.losses, ")") : "";
}
function ie(e, n) {
  var t = {},
    o = [];
  return n.forEach(function (n) {
    var r;
    (o = null == e || null === (r = e.games) || void 0 === r ? void 0 : r.filter(function (e) {
      var t;
      return (null == e || null === (t = e.details) || void 0 === t ? void 0 : t.league_short_name) === (null == n ? void 0 : n.slug);
    })).sort(function (e, n) {
      var t, o;
      return (null == e || null === (t = e.details) || void 0 === t ? void 0 : t.timestamp) - (null == n || null === (o = n.details) || void 0 === o ? void 0 : o.timestamp);
    }), t[n.slug] = o.map(function (e) {
      return function () {
        var e,
          n,
          t,
          o,
          r,
          a,
          d,
          l,
          i,
          s,
          c,
          _,
          u,
          b,
          p,
          m,
          f,
          T,
          v,
          h,
          y,
          O,
          g,
          w = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          x = (null === (e = w.current_line) || void 0 === e ? void 0 : e.fav_id) || (null === (n = w.opening_line) || void 0 === n ? void 0 : n.fav_id),
          E = "soccer" === (null === (t = w.details) || void 0 === t ? void 0 : t.sport) ? null === (o = w.home_team) || void 0 === o ? void 0 : o.city : null === (r = w.home_team) || void 0 === r ? void 0 : r.name,
          j = "soccer" === (null === (a = w.details) || void 0 === a ? void 0 : a.sport) ? null === (d = w.visiting_team) || void 0 === d ? void 0 : d.city : null === (l = w.visiting_team) || void 0 === l ? void 0 : l.name,
          S = (null === (i = w.current_line) || void 0 === i ? void 0 : i.home_money) || (null === (s = w.opening_line) || void 0 === s ? void 0 : s.home_money),
          q = (null === (c = w.current_line) || void 0 === c ? void 0 : c.away_money) || (null === (_ = w.opening_line) || void 0 === _ ? void 0 : _.away_money),
          k = (null === (u = w.current_line) || void 0 === u ? void 0 : u.fav_points) || (null === (b = w.opening_line) || void 0 === b ? void 0 : b.fav_points),
          L = null;
        S > 0 && (S = "+".concat(S)), q > 0 && (q = "+".concat(q)), k > 0 && (k = "+".concat(k)), (null !== (p = w.current_line) && void 0 !== p && p.total || null !== (m = w.opening_line) && void 0 !== m && m.total) && (L = "T: ".concat(((null === (f = w.current_line) || void 0 === f ? void 0 : f.total) || (null === (T = w.opening_line) || void 0 === T ? void 0 : T.total)).toFixed(1)));
        var N,
          I,
          P = (null === (v = w.home_team) || void 0 === v ? void 0 : v.id) === x ? S : L,
          C = (null === (h = w.visiting_team) || void 0 === h ? void 0 : h.id) === x ? q : L;
        return "basketball" === (null === (y = w.details) || void 0 === y ? void 0 : y.sport) && (P = (null === (N = w.home_team) || void 0 === N ? void 0 : N.id) === x ? k : L, C = (null === (I = w.visiting_team) || void 0 === I ? void 0 : I.id) === x ? k : L), {
          homeTeam: {
            name: E,
            record: le(w.home_team),
            logoUrl: null === (O = w.home_team) || void 0 === O ? void 0 : O.image_url_59,
            odds: P,
            isCanadian: w.home_team.is_canadian
          },
          visitingTeam: {
            name: j,
            record: le(w.visiting_team),
            logoUrl: null === (g = w.visiting_team) || void 0 === g ? void 0 : g.image_url_59,
            odds: C,
            isCanadian: w.visiting_team.is_canadian
          },
          details: w.details
        };
      }(e);
    });
  }), t;
}
var se = {
  LoadingSkeleton__cont: "LoadingSkeleton-module_LoadingSkeleton__cont__voTNN",
  LoadingSkeleton__animated: "LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl",
  shine: "LoadingSkeleton-module_shine__x0Cxs",
  grey: "LoadingSkeleton-module_grey__0i2c3",
  snBlue: "LoadingSkeleton-module_snBlue__Rn0Ew"
};
function ce() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) n[t] = arguments[t];
  return n.filter(Boolean).join(" ");
}
$(".LoadingSkeleton-module_LoadingSkeleton__cont__voTNN {\n    background-color: #ddd;\n}\n\n.LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl {\n    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n    border-radius: 5px;\n    background-size: 400% 100%;\n    animation-name: LoadingSkeleton-module_shine__x0Cxs;\n    animation-duration: 3s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n\n    &.LoadingSkeleton-module_grey__0i2c3 {\n        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n        background-size: 400% 100%;\n    }\n    &.LoadingSkeleton-module_snBlue__Rn0Ew {\n        background: linear-gradient(110deg, #156bac 8%, #156bac99 18%, #156bac 33%);\n        background-size: 400% 100%;\n    }\n}\n\n@keyframes LoadingSkeleton-module_shine__x0Cxs {\n    to {\n        background-position-x: -400%;\n    }\n}\n");
var _e = function _e(n) {
  var t = n.width,
    o = n.height,
    r = n.aspectRatio,
    a = n.opacity,
    d = n.round,
    l = n.animate,
    i = n.borderRadius,
    s = n.marginTop,
    c = n.color;
  return e.createElement("div", {
    className: ce(se.LoadingSkeleton__cont, l ? se.LoadingSkeleton__animated : "", se[c]),
    style: {
      width: t,
      height: o,
      aspectRatio: r,
      marginTop: s,
      opacity: a,
      borderRadius: d ? "50%" : i
    }
  });
};
_e.propTypes = {
  width: R.oneOfType([R.number, R.string]),
  height: R.oneOfType([R.number, R.string]),
  round: R.bool,
  animate: R.bool,
  borderRadius: R.number,
  color: R.oneOf(["grey", "snBlue"])
}, _e.defaultProps = {
  width: 32,
  height: 12,
  round: !1,
  animate: !0,
  borderRadius: 0,
  color: "grey"
};
var ue = {
  tabs__wrapper: "Tabs-module_tabs__wrapper__gg81P",
  tabs__cont: "Tabs-module_tabs__cont__qW1gu",
  oval: "Tabs-module_oval__J4P-b",
  tab: "Tabs-module_tab__LYqhc",
  selected: "Tabs-module_selected__ToUV8",
  modern: "Tabs-module_modern__Ajb47",
  arrow: "Tabs-module_arrow__7j-oT",
  retro: "Tabs-module_retro__jIY-R"
};
$('.Tabs-module_tabs__wrapper__gg81P {\n  display: block;\n}\n\n.Tabs-module_tabs__cont__qW1gu {\n  display: inline-flex;\n  flex-direction: row;\n  padding-right: 24px;\n  overflow: scroll;\n  width: 100%;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n.Tabs-module_tabs__cont__qW1gu.Tabs-module_oval__J4P-b {\n  background: #e9ecef;\n  border-radius: 30px;\n  padding-right: 0;\n  padding: 2px;\n}\n.Tabs-module_tabs__cont__qW1gu::-webkit-scrollbar {\n  display: none;\n}\n\n.Tabs-module_tab__LYqhc {\n  font-family: "protipo-narrow";\n  position: relative;\n  margin-left: 24px;\n  font-size: 15px;\n  padding-bottom: 4px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.Tabs-module_tab__LYqhc:first-of-type {\n  margin-left: 0px;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_oval__J4P-b {\n  font-size: 12px;\n  width: 189px;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  margin-left: 0;\n  transition: 0.3s cubic-bezier(0.1, 0.29, 0.76, 1.5);\n}\n.Tabs-module_tab__LYqhc.Tabs-module_oval__J4P-b.Tabs-module_selected__ToUV8 {\n  border-bottom-width: 0;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47 {\n  font-size: 14px;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47:hover {\n  color: #005eb8;\n  border-bottom: 2px solid #005eb8;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n  border-bottom-width: 4px;\n  text-shadow: 1px 0px 0px #002b49;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 .Tabs-module_arrow__7j-oT {\n  position: absolute;\n  left: calc(50% - 3px);\n  bottom: -7px;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  rotate: 270deg;\n}\n\n@media (prefers-color-scheme: dark) {\n  .Tabs-module_tabs__wrapper__gg81P {\n    color: #fff;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n    color: #fff;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n    border-bottom: 2px solid #005eb8 !important;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n    color: #fff;\n    border-bottom: 4px solid #fff;\n  }\n  .Tabs-module_tabs__cont__qW1gu {\n    color: #fff;\n    border-bottom-color: #005eb8;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_oval__J4P-b {\n    color: #0b223e;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n    border-bottom: 1px solid #adb5bd;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n    border-left: 7px solid #005eb8;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n    border-bottom: 1px solid #495057;\n    color: rgb(206, 212, 218);\n  }\n}\n.darkMode .Tabs-module_tabs__wrapper__gg81P {\n  color: #fff;\n}\n.darkMode .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n  color: #fff;\n}\n.darkMode .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n  border-bottom: 2px solid #005eb8 !important;\n}\n.darkMode .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n  color: #fff;\n  border-bottom: 4px solid #fff;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu {\n  color: #fff;\n  border-bottom-color: #005eb8;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_oval__J4P-b {\n  color: #0b223e;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n  border-bottom: 1px solid #adb5bd;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n  border-left: 7px solid #005eb8;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n  border-bottom: 1px solid #495057;\n  color: rgb(206, 212, 218);\n}\n\n@media (prefers-color-scheme: light) {\n  .Tabs-module_tabs__wrapper__gg81P {\n    color: #000;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n    color: #0b223e;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n    color: #005eb8;\n    border-bottom: 4px solid #005eb8;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n    color: #002b49;\n    border-bottom: 2px solid #002b49 !important;\n  }\n  .Tabs-module_tabs__cont__qW1gu {\n    color: #002b49;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n    border-bottom: 1px solid #d6dade;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n    border-left: 7px solid #002b49;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n    color: #002b49;\n    border-bottom: 1px solid #d6dade;\n  }\n}\n.lightMode .Tabs-module_tabs__wrapper__gg81P {\n  color: #000;\n}\n.lightMode .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n  color: #0b223e;\n}\n.lightMode .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n  color: #005eb8;\n  border-bottom: 4px solid #005eb8;\n}\n.lightMode .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n  color: #002b49;\n  border-bottom: 2px solid #002b49 !important;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu {\n  color: #002b49;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n  border-bottom: 1px solid #d6dade;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n  border-left: 7px solid #002b49;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n  color: #002b49;\n  border-bottom: 1px solid #d6dade;\n}');
var be = function be(r) {
  var a,
    d,
    l = r.tabs,
    i = r.spaceAboveTabs,
    c = r.spaceAboveTabsMobile,
    u = r.spaceBelowTabs,
    b = r.spaceBelowTabsMobile,
    p = r.selectedTabIndexOverride,
    m = r.underlineWidth,
    f = r.tabHeight,
    T = r.paddingLeft,
    v = r.tabType,
    h = r.activeBgTabColor,
    y = r.forceColorScheme,
    O = r.justifyContent,
    g = r.hideBottomBorder,
    w = r.hideTabList,
    x = function () {
      var e = "undefined" != typeof window;
      function o() {
        return {
          windowWidth: e ? window.innerWidth : null,
          windowHeight: e ? window.innerHeight : null
        };
      }
      var r = _(n(o()), 2),
        a = r[0],
        d = r[1];
      return t(function () {
        if (e) {
          var n = function n() {
            d(o());
          };
          return window.addEventListener("resize", n), function () {
            return window.removeEventListener("resize", n);
          };
        }
      }, [e]), a;
    }(),
    E = x.windowWidth < 768,
    j = o({});
  v = null === (a = v) || void 0 === a ? void 0 : a.toLowerCase();
  var S = _(n(p || 0), 2),
    q = S[0],
    k = S[1],
    L = _(n(q), 2),
    N = L[0],
    I = L[1];
  t(function () {
    p && k(p);
  }, [p]);
  var P = function P(e) {
      var n = j.current[e];
      n && (I(e), n.focus());
    },
    C = function C(e) {
      var n = l.length,
        t = function t() {
          return j.current[N].click();
        },
        o = {
          ArrowRight: function ArrowRight() {
            return P((N + 1) % n);
          },
          ArrowLeft: function ArrowLeft() {
            return P((N - 1 + n) % n);
          },
          Home: function Home() {
            return P(0);
          },
          End: function End() {
            return P(n - 1);
          },
          Enter: t,
          " ": t
        }[e.key];
      o && (e.preventDefault(), o());
    };
  return e.createElement("div", {
    className: ce(ue.tabs__wrapper, y)
  }, !w && e.createElement("div", {
    role: "tablist",
    "aria-label": "Tab List",
    "aria-orientation": "horizontal",
    className: "".concat(ue.tabs__cont, " ").concat(ue[v]),
    style: s({
      marginTop: E ? c : i,
      marginBottom: E ? b : u,
      paddingLeft: T,
      justifyContent: O
    }, g && {
      borderBottom: "none"
    })
  }, l.map(function (n, t) {
    var o = t === q ? ue.selected : "",
      r = {
        borderBottomWidth: m,
        height: f,
        background: t === q && h
      };
    return e.createElement("div", {
      key: "tab-".concat(t),
      role: "tab",
      "aria-selected": t === q,
      "aria-controls": "panel-id-".concat(t),
      id: "tab-id-".concat(t),
      ref: function ref(e) {
        return j.current[t] = e;
      },
      tabIndex: t === q ? 0 : -1,
      className: "".concat(ue.tab, " ").concat(o, " ").concat(ue[v]),
      style: r,
      onClick: function onClick() {
        return function (e, n) {
          k(n), e.onClick && e.onClick(), I(n);
        }(n, t);
      },
      onKeyDown: C
    }, n.displayName, "modern" === v && e.createElement("div", {
      className: ue.arrow
    }));
  })), e.createElement("div", {
    key: "tabpanel-".concat(q),
    id: "panel-id-".concat(q),
    role: "tabpanel",
    "aria-labelledby": "tab-id".concat(q),
    tabIndex: 0
  }, null === (d = l[q]) || void 0 === d ? void 0 : d.content));
};
be.propTypes = {
  forceColorScheme: R.oneOf(["darkMode", "lightMode", "system"]).isRequired,
  tabs: R.arrayOf(R.shape({
    id: R.string.isRequired,
    displayName: R.string.isRequired
  })),
  spaceAboveTabs: R.number,
  spaceAboveTabsMobile: R.number,
  spaceBelowTabs: R.number,
  spaceBelowTabsMobile: R.number,
  selectedTabIndexOverride: R.number,
  underlineWidth: R.number,
  tabHeight: R.number,
  paddingLeft: R.number,
  tabType: R.oneOf(["retro", "modern", "oval"]),
  activeBgTabColor: R.string,
  justifyContent: R.oneOf(["left", "center", "right"]),
  hideBottomBorder: R.bool,
  hideTabList: R.bool
}, be.defaultProps = {
  tabs: [],
  tabType: "retro",
  forceColorScheme: "lightMode",
  justifyContent: "left",
  hideBottomBorder: !1,
  hideTabList: !1
};
var pe = function pe(o) {
  var r = o.expectedGameCount,
    a = void 0 === r ? 6 : r,
    l = o.dataRefreshInterval,
    i = void 0 === l ? 3e4 : l,
    u = o.leaguesToShow,
    b = void 0 === u ? de : u,
    p = o.date,
    m = void 0 === p ? new Date().toISOString().substring(0, 10) : p,
    f = o.sponsorComponent,
    T = o.spaceAboveTabs,
    v = void 0 === T ? 16 : T,
    h = o.spaceAboveTabsMobile,
    y = void 0 === h ? 16 : h,
    O = o.openGamesInNewTab,
    g = void 0 !== O && O,
    w = o.useBasicTemplateGameLinks,
    x = void 0 !== w && w,
    E = _(n(null), 2),
    j = E[0],
    S = E[1],
    q = _(n(Array(a).fill({})), 2),
    k = q[0],
    L = q[1],
    N = _(n(b[0]), 2),
    I = N[0],
    P = N[1],
    C = _(n(null), 2),
    M = C[0],
    A = C[1],
    R = _(n(!1), 2),
    $ = R[0],
    le = R[1],
    se = m === new Date().toISOString().substring(0, 10),
    ce = b.map(function (e) {
      return s(s({}, e), {}, {
        id: e.slug,
        onClick: function onClick() {
          P(e);
        }
      });
    }),
    ue = function () {
      var e = d(c().mark(function e() {
        var n, t, o, r;
        return c().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, fetch("https://mobile-statsv2.sportsnet.ca/odds?day=".concat(m));
            case 2:
              return n = e.sent, e.next = 5, n.json();
            case 5:
              return t = e.sent, o = t.data, r = ie(o, b), e.abrupt("return", r);
            case 9:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function () {
        return e.apply(this, arguments);
      };
    }();
  return t(function () {
    ue().then(function (e) {
      S(e);
      for (var n = 0; n < ce.length; n++) {
        var t = ce[n];
        if (e[t.slug].length > 0) {
          P(t), A(n);
          break;
        }
      }
    });
    var e = setInterval(d(c().mark(function e() {
      return c().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            ue().then(function (e) {
              S(e);
            });
          case 1:
          case "end":
            return e.stop();
        }
      }, e);
    })), i);
    return function () {
      return clearInterval(e);
    };
  }, []), t(function () {
    j && L(j[I.slug].sort(function (e, n) {
      return !0 === (e.visitingTeam.isCanadian || e.homeTeam.isCanadian) && !1 === (n.visitingTeam.isCanadian || n.homeTeam.isCanadian) ? -1 : !1 === (e.visitingTeam.isCanadian || e.homeTeam.isCanadian) && !0 === (n.visitingTeam.isCanadian || n.homeTeam.isCanadian) ? 1 : 0;
    }));
  }, [j, I]), e.createElement("div", {
    className: Y
  }, e.createElement("div", {
    className: "".concat(F, " ").concat(k.length > a && U)
  }, e.createElement("div", {
    className: W
  }, !!f && e.createElement("div", {
    className: re
  }, f), e.createElement(be, {
    tabs: ce,
    selectedTabIndexOverride: M,
    spaceAboveTabs: v,
    spaceAboveTabsMobile: y
  }), !!f && e.createElement("div", {
    className: ae
  }, f)), k.length > 0 && e.createElement("div", {
    className: V
  }, k.map(function (n, t) {
    var o, r, d, l, i, s, c, _, u, b, p, m, f, T, v, h, y, O, w, E;
    if (t > a - 1 && !$) return null;
    var j,
      S,
      q,
      k,
      L = (j = null == n || null === (o = n.details) || void 0 === o ? void 0 : o.sport, S = null == n || null === (r = n.details) || void 0 === r ? void 0 : r.league_short_name, q = null == n || null === (d = n.details) || void 0 === d ? void 0 : d.id, k = x ? "?template=basic" : "", "https://www.sportsnet.ca/".concat(j, "/").concat(S, "/games/").concat(q).concat(k));
    return e.createElement("div", {
      className: B,
      key: t
    }, e.createElement("div", {
      className: D
    }, e.createElement("div", {
      className: z
    }, e.createElement("div", {
      className: G
    }, e.createElement("div", {
      className: J
    }, !(null !== (l = n.visitingTeam) && void 0 !== l && l.logoUrl) && e.createElement(_e, {
      round: !0,
      width: 24,
      height: 24
    }), (null === (i = n.visitingTeam) || void 0 === i ? void 0 : i.logoUrl) && e.createElement("img", {
      src: null === (s = n.visitingTeam) || void 0 === s ? void 0 : s.logoUrl
    })), e.createElement("div", {
      className: H
    }, !(null != n && null !== (c = n.visitingTeam) && void 0 !== c && c.name) && e.createElement(_e, {
      width: 150,
      height: 16,
      borderRadius: 4
    }), (null == n || null === (_ = n.visitingTeam) || void 0 === _ ? void 0 : _.name) && e.createElement(e.Fragment, null, e.createElement("div", null, n.visitingTeam.name), e.createElement("div", {
      className: X
    }, " ", null == n || null === (u = n.visitingTeam) || void 0 === u ? void 0 : u.record)))), e.createElement("div", {
      className: K
    }, !(null != n && null !== (b = n.visitingTeam) && void 0 !== b && b.odds) && e.createElement(_e, {
      width: 43,
      height: 15,
      borderRadius: 4
    }), (null == n || null === (p = n.visitingTeam) || void 0 === p ? void 0 : p.odds) && e.createElement("div", null, n.visitingTeam.odds))), e.createElement("div", {
      className: z
    }, e.createElement("div", {
      className: G
    }, e.createElement("div", {
      className: J
    }, !(null !== (m = n.homeTeam) && void 0 !== m && m.logoUrl) && e.createElement(_e, {
      round: !0,
      width: 24,
      height: 24
    }), (null === (f = n.visitingTeam) || void 0 === f ? void 0 : f.logoUrl) && e.createElement("img", {
      src: null === (T = n.homeTeam) || void 0 === T ? void 0 : T.logoUrl
    })), e.createElement("div", {
      className: H
    }, !(null != n && null !== (v = n.homeTeam) && void 0 !== v && v.name) && e.createElement(_e, {
      width: 165,
      height: 16,
      borderRadius: 4
    }), (null == n || null === (h = n.homeTeam) || void 0 === h ? void 0 : h.name) && e.createElement(e.Fragment, null, e.createElement("div", null, null == n || null === (y = n.homeTeam) || void 0 === y ? void 0 : y.name), e.createElement("div", {
      className: X
    }, " ", null == n || null === (O = n.homeTeam) || void 0 === O ? void 0 : O.record)))), e.createElement("div", {
      className: K
    }, !(null != n && null !== (w = n.homeTeam) && void 0 !== w && w.odds) && e.createElement(_e, {
      width: 35,
      height: 15,
      borderRadius: 4
    }), (null == n || null === (E = n.homeTeam) || void 0 === E ? void 0 : E.odds) && e.createElement("div", null, n.homeTeam.odds))), e.createElement("a", {
      href: L,
      rel: "noreferrer",
      target: g ? "_blank" : "",
      className: Z
    })));
  })), 0 === k.length && e.createElement("div", {
    className: Q
  }, "No ", I.displayName, " games are scheduled for", " ", se ? "today" : m, ".")), k.length > 6 && e.createElement("div", {
    onClick: function onClick() {
      return le(!$);
    }
  }, e.createElement("div", {
    className: ee
  }, e.createElement("span", null, $ ? "See less odds" : "See all odds"), e.createElement("span", {
    className: "".concat(ne, " ").concat($ ? te : oe)
  }))));
};
pe.propTypes = {
  expectedGameCount: R.number,
  dataRefreshInterval: R.number,
  leaguesToShow: R.arrayOf(R.shape({
    slug: R.string.isRequired,
    displayName: R.number.isRequired
  })),
  date: R.string,
  sponsorComponent: R.element,
  spaceAboveTabs: R.number,
  spaceAboveTabsMobile: R.number,
  openGamesInNewTab: R.bool,
  useBasicTemplateGameLinks: R.bool
}, pe.defaultProps = {
  expectedGameCount: 6,
  dataRefreshInterval: 3e4,
  leaguesToShow: de,
  date: new Date().toISOString().substring(0, 10),
  spaceAboveTabs: 16,
  spaceAboveTabsMobile: 16,
  openGamesInNewTab: !1,
  useBasicTemplateGameLinks: !1
};
export { pe as OddsTable, pe as default };